import React, { useState } from "react";
import "./Pricing.css";
import { Briefcase, Users, Crown } from "lucide-react";
import Trial from "./Trial";
import {
    PRICING_DATA,
    RENTAL_PRICING,
    calculateGST,
    formatPriceForRegion,
    getRegionPrice,
    getRentalPrice,
} from "./pricingConfig";

const planIcons = {
    briefcase: <Briefcase className="w-6 h-6 text-indigo-500" />,
    crown: <Crown className="w-6 h-6 text-yellow-500" />,
    users: <Users className="w-6 h-6 text-blue-500" />,
};

export default function Pricing() {
    const [selectedRegion, setSelectedRegion] = useState("India");
    const [rentalPlan, setRentalPlan] = useState("Single User");
    const [rentalMonths, setRentalMonths] = useState(1);
    const formatPrice = (price) => formatPriceForRegion(price, selectedRegion);
    const selectedRentalPrice = getRentalPrice(rentalPlan, rentalMonths);

    return (
        <div>
            <section className="pricing-section">
                <div className="pricing-content">
                    <h2 className="title">Find a Suitable Plan</h2>
                    <p className="subtitle">
                        Simple, transparent pricing that scales with your usage and needs
                    </p>

                    <div className="tabs">
                        {PRICING_DATA.regions.map((region) => (
                            <button
                                key={region}
                                className={`tab ${selectedRegion === region ? "active" : ""}`}
                                onClick={() => setSelectedRegion(region)}
                            >
                                {region}
                            </button>
                        ))}
                    </div>

                    <div className="pricing-boxes">
                        {PRICING_DATA.plans.map((plan, index) => {
                            const regionPrice = getRegionPrice(plan, selectedRegion);

                            const displayPrice = (
                                <>
                                    {formatPrice(regionPrice)}
                                    <span className="gst-info">
                                        + 18% GST ({formatPrice(calculateGST(regionPrice))})
                                    </span>
                                </>
                            );

                            return (
                                <div
                                    key={index}
                                    className={`pricing-box ${plan.popular ? "popular" : ""}`}
                                >
                                    {plan.popular && (
                                        <span className="popular-badge-fancy"> Most Popular </span>
                                    )}

                                    <h3 className="plan-name">
                                        {planIcons[plan.iconKey]} {plan.name}
                                    </h3>
                                    <p className="plan-price">{displayPrice}</p>

                                    <p className="price-note">
                                        {selectedRegion === "India"
                                            ? "Perpetual License"
                                            : "Yearly Subscription"}
                                    </p>
                                    {/* {isSingleUser && selectedRegion === "India" && (
                                        <div className="ribbon-folded-left">20% Offer Limited Time</div>
                                    )} */}
                                    <div className="plan-features">
                                        <ul>
                                            {plan.features.map((f, i) => (
                                                <li key={i}>{f}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <a href="/Demo">
                                        <button>Buy Now</button>
                                    </a>
                                </div>
                            );
                        })}

                        {selectedRegion === "India" && (
                            <div className="pricing-box rental bright">
                                <h3 className="plan-name">Rental Plan</h3>

                                <select
                                    value={rentalPlan}
                                    onChange={(e) => setRentalPlan(e.target.value)}
                                    className="rental-dropdown"
                                >
                                    {Object.keys(RENTAL_PRICING).map((plan) => (
                                        <option key={plan} value={plan}>
                                            {plan}
                                        </option>
                                    ))}
                                </select>

                                <div className="rental-months">
                                    {[1, 3, 12].map((m) => (
                                        <label key={m}>
                                            <input
                                                type="radio"
                                                name="months"
                                                value={m}
                                                checked={rentalMonths === m}
                                                onChange={() => setRentalMonths(m)}
                                            />{" "}
                                            {m} month{m > 1 ? "s" : ""}
                                        </label>
                                    ))}
                                </div>

                                <p className="plan-price">
                                    {formatPrice(selectedRentalPrice)}
                                    <span className="gst-info">
                                        + 18% GST ({formatPrice(calculateGST(selectedRentalPrice))})
                                    </span>
                                </p>
                                <p className="price-note">Rental Subscription</p>

                                <div className="plan-features">
                                    <ul>
                                        {RENTAL_PRICING[rentalPlan].features.map((f, i) => (
                                            <li key={i}>{f}</li>
                                        ))}
                                    </ul>
                                </div>

                                <a href="/Demo">
                                    <button>Buy Now</button>
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </section>
            <Trial />
        </div>
    );
}
